import spanish from 'vuetify/lib/locale/es';

export const es = {
  ...spanish,

  dataTable: {
    ...spanish.dataTable,
    itemsPerPageText: 'Mostrar en grupo de:',
  },
};
